/** @format */
import Diagram_kyeongbok from '@/assets/diagram/kyeongbok.png';
import Diagram_templestay from '@/assets/diagram/templestay.png';
import Diagram_bluehouse from '@/assets/diagram/bluehouse.png';
import Diagram_warmemorial from '@/assets/diagram/warmemorial.png';
import Diagram_museumtown from '@/assets/diagram/museumtown.png';
import Diagram_arttown from '@/assets/diagram/arttown.png';
import Diagram_seoul284 from '@/assets/diagram/seoul284.png';
import Diagram_koreanstylehouse from '@/assets/diagram/koreanstylehouse.png';
import Diagram_seoul_lib from '@/assets/diagram/seoul_lib.png';
import Diagram_changduk from '@/assets/diagram/changduk.png';

import Title_kyeongbok from '@/assets/title/cn/kyeongbok.png';
import Title_templestay from '@/assets/title/cn/templestay.png';
import Title_bluehouse from '@/assets/title/cn/bluehouse.png';
import Title_warmemorial from '@/assets/title/cn/warmemorial.png';
import Title_museumtown from '@/assets/title/cn/museumtown.png';
import Title_arttown from '@/assets/title/cn/arttown.png';
import Title_seoul284 from '@/assets/title/cn/seoul284.png';
import Title_koreanstylehouse from '@/assets/title/cn/koreanstylehouse.png';
import Title_seoul_lib from '@/assets/title/cn/seoul_lib.png';
import Title_changduk from '@/assets/title/cn/changduk.png';

export default {
    kyeongbok: {
        diagram: Diagram_kyeongbok,
        title: Title_kyeongbok,
        msg: `<p>景福宫是朝鲜王朝第一法宫，北靠北岳山坐落，光华门前有宽阔的六曹街展开，也是国都——汉阳（首尔）城市计划的中心。1395年由太祖李成桂创建，1592年由壬辰兴宣大院君主导重建的景福宫有500多个建筑像迷宫一样组成，形成壮观的景象，但曾因倭乱被烧毁，后来在1867年高宗时期重建。</p>
 
<p>宫殿里有王和官吏的政务设施、王族的生活空间、为休息提供的御苑空间，还有王妃的中宫、世子的东宫、高宗建立的乾清宫等，这里也是宫殿里有许多小宫殿复杂汇集的地方。但是在日本殖民统治时期，大多数建筑被撤回，只留下勤政殿等极其一小部分中心建筑，并建造了朝鲜总督府办公楼，遮住了宫殿。幸好从1990年开始正式推进复原项目，拆除建筑并修复了兴礼门一带，正在寻回王和王妃的寝殿、东宫、乾清宫、泰元殿一带的面貌。</p>`,
        scene: 'scene_kyeongbok',
        vr_url:
            'https://look360.kr/vr/2020sitm_royalpalace/2020sitm_royalpalace_cn',
        site_url:
            'http://www.royalpalace.go.kr:8080/html/eng_gbg/main/main.jsp',
        narration: 'kyeongbok_cn',
        title_maxwidth: 267,
    },
    templestay: {
        diagram: Diagram_templestay,
        title: Title_templestay,
        msg: `<p>这里韩国佛教最大宗派——曹溪宗的代表寺院。1910年由韩龙云等主导建立的“觉皇寺”经过1938年的大面积整修，曾被称为“太古寺”；而1954年通过去除日本殖民时期残余的佛教净化运动，就定下了如今的名字。“曹溪”这一名称来自被称为中国禅佛教六大祖师且被推崇为修行指标的“慧能大师”曾生活过的曹溪山。</p>

<p>中心建筑大雄殿是在太古寺重建时期把全罗北道井邑的寺庙建筑原封不动引进来的，大大的柱子彰显古色古香的华丽感。位于前院的七层石塔供奉着佛祖的真身舍利，树龄达500年的白皮松和400年的槐树仿佛守护着大雄殿建筑一样围绕在周围。2006年经过大规模修复工程，去除日本殖民统治时期的残余，充分具备了一柱门等寺庙的威仪，而通过拜访寺庙的无数信徒和轻轻的佛经声、隐隐的香气，在首尔市区内传播佛祖的慈悲。在曹溪宗总本寺建筑周围有寺院餐厅和茶馆，以及销售佛教用品的商店，营造了一条佛教街。一同存在的佛教中央博物馆是管理和展出在韩国寺院很难保管的佛教文化遗产的地方，可以看到珍贵的韩国国家美术宝物。</p>

<p>在曹溪寺里佛教徒和访客之间没有任何障碍，可以在繁忙中静下心来，保持安静的气氛，并让为生活奔波的人不失温暖，运营只要想共同参与就能马上一起的寺院寄宿。</p>`,
        scene: 'scene_templestay',
        vr_url: 'https://look360.kr/vr/2020sitm_jogyesa/2020sitm_jogyesa_cn',
        site_url: 'http://www.jogyesa.kr/user/english/',
        narration: 'templestay_cn',
    },
    bluehouse: {
        diagram: Diagram_bluehouse,
        title: Title_bluehouse,
        msg: `<p>青瓦台代表“用蓝色砖瓦砌成屋顶的建筑”。这里是韩国总统工作和生活的空间。可以查看从高丽时代作为宫阙遗址的过去的青瓦台一直到如今的青瓦台建成的整个过程，让人一目了然。</p>

<p>位于青瓦台前院的青瓦台厢房是能让人们了解韩国旅游景点、青瓦台及历届总统业绩的综合旅游宣传馆，1楼由韩国旅游展馆、纪念品店、休息处，2楼由青瓦台馆和国民沟通体验馆组成。</p>

<p>韩国旅游展馆由两个主题构成，是查看包括青瓦台里令人感兴趣的故事，到理解总统业绩的展馆，以及介绍美丽韩国的文化和旅游胜地的展馆。美国总统夫人梅拉尼娅•特朗普和金正淑女士一起走过的青瓦台“不老门”连接这两个空间。</p>

<p>青瓦台馆介绍文在寅总统和如今的青瓦台。作为可以共享现政府的过去、现在、未来愿景的历史纪念馆与文化宣传馆，这里是原封不动地重现实际总统办公室的空间。</p>`,
        scene: 'scene_bluehouse',
        vr_url:
            'https://look360.kr/vr/2020sitm_cwdsarangchae/2020sitm_cwdsarangchae_cn',
        site_url: 'https://cwdsarangchae.kr/chn/',
        narration: 'bluehouse_cn',
        title_maxwidth: 473,
    },
    warmemorial: {
        diagram: Diagram_warmemorial,
        title: Title_warmemorial,
        msg: `<p>这里是追悼战争伤痛并祈求和平的展览馆。在约82.6平方公里的土地上，于1994年竣工的纪念馆是一个展出1万多件与战争相关的纪念物的大规模空间。正门左右有广开土大王碑的实际模型和韩国军官与人民军士兵拥抱的形状的兄弟雕像，还有融合史前时代的青铜剑和生命之树形状的象征塔屹立在中央。兄弟雕像这个雕塑包含朝鲜战争期间成为把枪口对准对方的敌人相见的真实兄弟的故事。</p>

<p>经过和平广场，相连接的建筑是分为6个展示区域的室内展馆。水和光相融的护国追慕室保管建军以来牺牲的17万人名字簿册的严肃空间。以展现从史前时代到大韩帝国为止这片土地使用的许多武器的战争历史室为开始，在6•25战争室、海外派兵室、韩国军发展室等展室可以看到从朝鲜战争开始派到世界各地并积极发挥作用的韩国军队和不断发展的军事装备。</p>`,
        scene: 'scene_warmemorial',
        vr_url: 'https://look360.kr/vr/2020sitm_warmemo/2020sitm_warmemo_cn',
        site_url: 'https://www.warmemo.or.kr/LNG/main.do?lan=cn',
        narration: 'warmemorial_cn',
        title_maxwidth: 397,
    },
    museumtown: {
        diagram: Diagram_museumtown,
        title: Title_museumtown,
        msg: `<p>敦义门博物馆村原计划是在全面拆迁之后建成公园，但其历史价值备受认可，于是选择首尔型城市再生方式，是在2017年整个村庄被建成博物馆的历史文化空间。起初是为了艺术家提供的展览空间，但从2019年4月起以举行展览、活动、体验的市民参与型空间再次诞生。空间由村展馆（16个栋）、体验教育馆（9个栋）、村创作所（9个栋）等三部分组成。</p>

<p>其中核心空间“村展馆”里设置有纪念3•1运动和大韩民国临时政府成立100周年的主题展馆“独立运动家之家”、还原20世纪60~80年代家庭房屋的“生活史展馆”、展出市民收藏品的“市民画廊”等。此外，由传统文化名人运营的“体验教育馆”是提供与传统韩屋融合的韩纸工艺、书法、刺绣工艺、楮皮纸工坊、茶和嘉俳等体验活动的空间。而且通过公开招募征集的运营者运营的“村创作所”是展出各时代小巷游戏方法和玩具并能体验的空间。另外，还利用村里的院子和胡同等的外部空间举行许多活动，为观众提供丰富多样的趣味活动。</p>`,
        scene: 'scene_museumtown',
        vr_url:
            'https://look360.kr/vr/2020sitm_dmvillage/2020sitm_dmvillage_cn',
        site_url: 'http://dmvillage.info',
        narration: 'museumtown_cn',
        title_maxwidth: 545,
    },
    arttown: {
        diagram: Diagram_arttown,
        title: Title_arttown,
        msg: `<p>文来洞是日本殖民统治时期随着棉纱厂进入，与工厂结下渊源的地方。据说当时把纺纱机器叫做“Mullae”，这里的地名“文来洞”就定了下来。之后钢铁工厂、制铁商聚到这里，目前有许多艺术家聚集，成为艺术和铁器厂共存的空间。</p>

<p>在除了胡同街以外，想不到其他合适词语的空间画着没有任何规则、限制的壁画；走到胡同街的拐角，每次转身都能看到四处有突如其来的风景。这里称得上是没有屋顶的美术馆。</p>

<p>在首尔历史悠久的工业区是工业开始比农业更受优待的近代化的痕迹，所以在比如今工厂更密集的70年代，文来洞是工人和机器以及钢铁的世界。到现在能看到那个世界的风景还留在胡同的各处。在这个空间之上有人挥笔涂上颜色，并用艺术家的双手把首尔常见的小区改成独特的社区。</p>`,
        scene: 'scene_arttown',
        vr_url:
            'https://look360.kr/vr/2020sitm_mullaertrefactory/2020sitm_mullaertrefactory_cn',
        site_url: '',
        narration: 'arttown_cn',
    },
    seoul284: {
        diagram: Diagram_seoul284,
        title: Title_seoul284,
        msg: `<p>把自从KTX新车站开通之后已丧失火车站功能的旧首尔车站原样复原，营造成综合文化空间，并在2012年4月正式成立。位于首尔特别市中区统一路1号。</p>

<p>据说这座宏伟的砖楼以瑞士卢塞恩站为模型，曾经是殖民地关卡。日本曾试图通过这里，连接满洲，乃至莫斯科和柏林。虽然因为战败，日帝的欲望消失了，但首尔站仍然是韩半岛交通的中心。自从10多年前新车站建成，曾经的首尔车站以名为“文化站首尔284”的综合文化空间改头换面。</p>

<p>名称是通过国民征集得来的，而“284”代表旧首尔车站是史迹第284号国家指定文化遗产。这个空间在保存历史遗迹的面貌和价值的同时，体现出有不同文化交汇的车站的象征性，目前举行讲座、演出、展览、研究等许多活动。</p>`,
        scene: 'scene_seoul284',
        vr_url: 'https://look360.kr/vr/2020sitm_seoul284/2020sitm_seoul284_cn',
        site_url: 'https://www.seoul284.org/english/',
        narration: 'seoul284_cn',
        title_maxwidth: 545,
    },
    koreanstylehouse: {
        diagram: Diagram_koreanstylehouse,
        title: Title_koreanstylehouse,
        msg: `<p>北村是朝鲜时代营造的两班阶层的住宅区，直到20世纪20年代没有太大的变化，但随着20世纪30年代首尔的行政区域扩大，城市结构变得更现代，也发生了变化。住宅经营企业购入北村的大型地皮和林地，在那里集体建造了大规模的韩屋，目前有韩屋密集的嘉会洞、三清洞、桂洞的韩屋住宅区都是在这一时期形成的。</p>

<p>位于北村韩屋村的韩屋文化院是在以韩屋村闻名的首尔北村的韩屋教育专业机构，2000年3月为了广泛传播、继承和发展韩屋的价值和美丽而设立。韩屋文化院通过研究韩屋的法式和技法、技术史，不仅培养专业人才，还提供丰富多样的讲座，有50多名文化遗产和传统文化专家指导后辈。还自主运营</p>`,
        scene: 'scene_koreanstylehouse',
        vr_url:
            'https://look360.kr/vr/2020sitm_hanok_seoul/2020sitm_hanok_seoul_cn',
        site_url: 'http://www.hanok.org',
        narration: 'koreanstylehouse_cn',
    },
    changduk: {
        diagram: Diagram_changduk,
        title: Title_changduk,
        msg: `<p>因代表宫殿的庭院，故名为禁苑；位于宫殿北边，故名为北苑；位于后方的庭院则被称为后苑。准确地说，后苑是昌德宫的后苑，但该后苑位于昌德宫和昌庆宫的后方，自然由两个宫殿共有。</p>

<p>后苑共由五大区域组成。第一部分是以芙蓉池为中心，有芙蓉亭、宙合楼、暎花堂、书香阁等建筑的地区，越过该地区的山脊与第二区域相连。第二部分是爱莲池和爱莲亭、以及演庆堂所在的区域，再越过山脊与第三区域相连。第三部分是有观缆亭和尊德亭及砭愚榭的区域。而且越过该区域山脊的尽头与玉流川地区相连。</p>

<p>第四部分是以玉流川为中心，逍遥亭、清漪亭、太极亭等所在的区域。第五部分是在西北方建有新璿源殿的区域。</p>`,
        scene: 'scene_changduk_buyongji',
        vr_url: 'https://look360.kr/vr/2020sitm_cdg/2020sitm_cdg_cn',
        site_url: 'http://www.cdg.go.kr/eng/',
        narration: 'changduk_cn',
        title_maxwidth: 394,
    },
    seoul_lib: {
        diagram: Diagram_seoul_lib,
        title: Title_seoul_lib,
        msg: `<p>这里是把首尔特别市的纪录和信息和市民共享的知识空间。怀抱沟通的象征——首尔广场的首尔记录文化馆是首尔市民和首尔特别市的沟通空间，也是连接首尔的过去和现在、以及未来的历史空间。</p>

<p>展览馆通过把2014年进行的“首尔广场记录收集和内容开发项目”及2015年首尔图书馆为市民开放的“首尔广场记录展示项目”综合整理并完成现行化的记录展，为了讲故事而设定的虚拟首尔市民GUBO在成长过程中经历的个人历史和韩国现代史以首尔广场为中心展开。</p>

<p>过去的市长室是解放以后到2008年5月，历届首尔市长使用了60多年的办公空间。市长室位于旧市政厅大楼三楼的正中央，并且由工作室和接待室等组成，复原的空间原封不动地再现当时的旧办公设备、家具等。</p>`,
        scene: 'scene_seoul_lib',
        vr_url:
            'https://look360.kr/vr/2020sitm_lib_seoul/2020sitm_lib_seoul_cn',
        site_url: 'https://lib.seoul.go.kr/rwww/html/ch/main.jsp',
        narration: 'seoul_lib_cn',
    },
};
/*
https://look360.kr/project/ioconvex_intro/#/cn/kyeongbok
https://look360.kr/project/ioconvex_intro/#/cn/templestay
https://look360.kr/project/ioconvex_intro/#/cn/bluehouse
https://look360.kr/project/ioconvex_intro/#/cn/warmemorial
https://look360.kr/project/ioconvex_intro/#/cn/museumtown
https://look360.kr/project/ioconvex_intro/#/cn/arttown
https://look360.kr/project/ioconvex_intro/#/cn/seoul284
https://look360.kr/project/ioconvex_intro/#/cn/koreanstylehouse
https://look360.kr/project/ioconvex_intro/#/cn/changduk
https://look360.kr/project/ioconvex_intro/#/cn/seoul_lib

http://localhost:8080/#/cn/kyeongbok
http://localhost:8080/#/cn/templestay
http://localhost:8080/#/cn/bluehouse
http://localhost:8080/#/cn/warmemorial
http://localhost:8080/#/cn/museumtown
http://localhost:8080/#/cn/arttown
http://localhost:8080/#/cn/seoul284
http://localhost:8080/#/cn/koreanstylehouse
http://localhost:8080/#/cn/changduk
http://localhost:8080/#/cn/seoul_lib
*/
